<div class="erp-fetch-progress" [class.erp-fetch-progress--active]="loading$ | async" aria-live="polite">
    <div class="erp-fetch-progress__track">
        <div class="erp-fetch-progress__bar"></div>
    </div>
    <span class="erp-fetch-progress__label" *ngIf="loading$ | async">Récupération des données…</span>
</div>
